export const findHighlightedSearch = (searchValue: string, target: string) => {
  if (searchValue && target) {
    const purifiedTarget = target?.replace(/<script.*?>.*?<\/script>/gi, "");
    const parser = new DOMParser();

    const doc = parser.parseFromString(purifiedTarget, "text/html");
    const text = doc.body.textContent || "";
    const checkValidSearchChars = searchValue.replace(
      /[.*+?^${}()|[\]\\]/g,
      "\\$&"
    );
    const regex = new RegExp(`(${checkValidSearchChars})`, "gi");

    return text.replace(regex, "<mark>$1</mark>");
  }

  return "";
};
